/**
 * 検索ページ専用機能
 */

// import global variables.

import {LOCATION, getStorageItem, BODY_ELEMENT} from '../utils/global';
import {Filter} from './filter';
import {Sort} from './sort';
import {Modal} from './modal';
import {ChangeCartButton} from './changeCartButton';
import {updateAllButtonState} from './favoriteButton';

const baseUrl = '/search/api/';

/**
 * fetchData - APIからHTMLテキストを取得
 * @param  {String} url APIへリクエストするパラメータ付きURL
 * @return {Object}     APIから返却されたJSON（エラー時は空のテキスト）
 */
const fetchData = async (url) => {
    try {
        const response = await fetch(url);
        const json = await response.json();

        return json;
    } catch (e) {
        return '';
    } finally {
        const loading = document.querySelector('.js-loading-icon');
        const productItemBox = document.querySelector('.p-box.p-box--slim.js-filter.js-sort.js-loading');

        loading.classList.add('is-hidden');
        productItemBox.classList.add('is-visible');
    }
};

const releaseParameterMap = {
    '-1': '発売前',
    92: '3か月以内',
    365: '1年以内',
    1095: '3年以内'
};

const conditionParameterMap = {
    special: 'きゃにめ特典付き',
    limited: 'きゃにめ限定商品',
    funclub: 'ファンクラブ会員限定',
    new: '新着商品',
    close: '販売終了間近商品',
    recommend: 'おすすめ商品'
};

const favoriteInputNames = [
    'product',
    'work',
    'artist'
];

/**
 * getFavoriteProductIds - ローカルストレージからお気に入りに登録されている商品のidを取得
 * @param  {String} 必要なお気に入りデータの種類（product | work | artist）
 * @return {String} お気に入りに登録されている商品のidが「,」で連結された文字列
 */
const getFavoriteProductIds = (keyName) => {
    const favoriteData = JSON.parse(getStorageItem('favorite')) || {};
    const favoriteKeys = Object.keys(favoriteData);

    if (!favoriteKeys.length || !favoriteData.hasOwnProperty(keyName)) {
        return '';
    }

    return favoriteData[keyName].join(',');
};

/**
 * デフォルト実行処理
 * @param  {HTMLElement} rootElement        ルートとなる要素
 * @param  {HTMLElement} categoryListTarget リストが追加される要素
 * @param  {HTMLElement} inputKeywordTarget キーワード入力欄の要素
 * @return {Void}
 */
export default (rootElement, categoryListTarget, inputKeywordTarget) => {
    const searchParams = new URLSearchParams(LOCATION.param);
    const releaseItems = searchParams.get('release') || '';
    const conditionItems = searchParams.has('condition') ? searchParams.get('condition').split(',') : [];
    const searchKeyword = searchParams.get('keyword') || '';
    const conditions = [];

    // パラメータにローカルストレージのお気に入りアイテムをセット
    for (const name of favoriteInputNames) {
        const value = getFavoriteProductIds(name);

        if (value === '') {
            continue;
        }
        searchParams.set(name, value);
    }

    // ルートとなる要素がform要素でない または 引数の要素が1つでも欠けていたら実装しない
    if ((!rootElement || !categoryListTarget || !inputKeywordTarget) || rootElement.tagName.toLowerCase() !== 'form') {
        return;
    }

    // キーワード入力欄に検索ワードを設定
    inputKeywordTarget.value = searchKeyword;

    // ルート要素内の[name="release"]への処理
    for (const element of rootElement.elements.release) {
        const isIncludes = releaseItems.includes(element.value);

        // URLパラメータに同じvalueが存在する場合、検索条件リストを追加
        if (isIncludes) {
            conditions.push(`<li class="p-linklist-category__item">${releaseParameterMap[element.value]}</li>`);
        }

        element.checked = isIncludes;
    }

    // ルート要素内の[name="condition"]への処理
    for (const element of rootElement.elements.condition) {
        const isIncludes = conditionItems.includes(element.value);

        // URLパラメータに同じvalueが存在する場合、検索条件リストを追加
        if (isIncludes) {
            conditions.push(`<li class="p-linklist-category__item">${conditionParameterMap[element.value]}</li>`);
        }

        element.checked = isIncludes;
    }

    // 検索条件リストを追加（検索条件がない場合はテキストを表示）
    categoryListTarget.insertAdjacentHTML('beforeend', !conditions.length ? '<p class="c-text-weak">指定なし</p>' : `<ul class="p-linklist-category">${conditions.join('')}</ul>`);

    window.addEventListener('load', () => {
        const targetElement = document.querySelector('.js-more__container');

        fetchData(`${baseUrl}?${searchParams.toString()}`).then((json) => {
            if (!json) {
                targetElement.insertAdjacentHTML('beforeend', ' ');
                targetElement.insertAdjacentHTML('afterend', '<p class="c-text-notice">該当する商品が存在しません</p>');
                targetElement.remove();
            } else {
                const {data, modal} = json;

                BODY_ELEMENT.insertAdjacentHTML('beforeend', modal);
                targetElement.insertAdjacentHTML('beforeend', data);
                [targetElement.closest('.js-filter')].forEach((element) => new Filter(element));
                [targetElement.closest('.js-sort')].forEach((element) => new Sort(element));
                document.querySelectorAll('.js-modal').forEach((element) => new Modal(element));
                document.querySelectorAll('.js-change-cart-button').forEach((element) => new ChangeCartButton(element));
                require('loading-attribute-polyfill/loading-attribute-polyfill');
                updateAllButtonState(targetElement.querySelectorAll('.c-button-favorite'));
            }
        });
    });
};
